import SocialIcons from "./Socialicons"
export default SocialIcons
